module.exports = __webpack_public_path__ + "img/61.3.TP.d10cb698.png";